import React, { useState } from 'react';

function formatDate(dateStr: string): string {
    const [yearStr, monthStr, dayStr] = dateStr.split('-');
    const year = Number(yearStr);
    const month = Number(monthStr);
    const day = Number(dayStr);

    if (!year || !month || !day) return dateStr; // fallback for invalid input

    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    const ordinal = (n: number): string => {
        if (n > 3 && n < 21) return 'th';
        switch (n % 10) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    };

    const monthName = monthNames[month - 1] ?? 'Invalid';

    return `${monthName} ${day}${ordinal(day)}, ${year}`;
}

type DateListProps = {
    dates: string[]; // List of ISO date strings like '2024-07-13'
    maxVisible?: number; // Optional number of dates to show by default
};

export const FriendlyDateList: React.FC<DateListProps> = ({
    dates,
    maxVisible = 4
}) => {
    const [expanded, setExpanded] = useState(false);

    const formattedDates: string[] = dates.map(formatDate);
    const visibleDates = expanded
        ? formattedDates
        : formattedDates.slice(0, maxVisible);
    const hiddenCount = formattedDates.length - visibleDates.length;

    const rows: string[][] = [];
    for (let i = 0; i < visibleDates.length; i += 2) {
        rows.push(visibleDates.slice(i, i + 2));
    }

    const toggleText = expanded ? 'Show less' : `+${hiddenCount} more`;

    return (
        <div>
            {visibleDates.map((day, idx) => (
                <div key={idx} className="PRELIMINARY_DATES">
                    {day}
                </div>
            ))}
            {formattedDates.length > maxVisible && (
                <div>
                    <button
                        onClick={() => setExpanded(prev => !prev)}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: 'blue',
                            cursor: 'pointer'
                        }}
                    >
                        {toggleText}
                    </button>
                </div>
            )}
        </div>
    );
};

type DateRangeProps = {
    startDate: string; // ISO date string like '2024-07-13'
    endDate: string; // ISO date string like '2024-07-20'
};

export const FriendlyDateRange: React.FC<DateRangeProps> = ({
    startDate,
    endDate
}) => {
    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    return (
        <span>
            {formattedStart} - {formattedEnd}
        </span>
    );
};
